import React from "react";
import { useParams } from "react-router-dom";
import { Tooltip } from "@mui/material";

import { useWizard } from "components/wizard/WizardContext";
import ViewEmployeeName from "views/pages/manage/viewEmployeeName";

const UserStateSummary = () => {
  const { id } = useParams();

  const { values } = useWizard();
  const {
    language,
    academicCareer,
    attribute,
    classes,
    courses,
    board,
    stream,
    year,
    materialInfo,
    createdOn,
    updatedOn,
    createdBy,
    updatedBy,
  } = values;

  const selectedMaterials = materialInfo.filter((item) => !item?.isNew);

  return (
    <>
      <h2 className="text-bold">Summary</h2>

      <h4 className="my-3 text-bold">Course Details</h4>
      <div className="d-flex align-items-center justify-content-between">
        <label className="text-sm">Career:</label>
        <span className="text-bold text-sm text-dark mb-1">
          {academicCareer.label || "-"}
        </span>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <label className="text-sm">Class:</label>
        <span className="text-bold text-sm text-dark mb-1 text-capitalize">
          {classes.label || "-"}
        </span>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <label className="text-sm">Attribute:</label>
        <span className="text-bold text-sm text-dark mb-1">
          {attribute.label || "-"}
        </span>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <label className="text-sm">Language:</label>
        <span className="text-bold text-sm text-dark mb-1">
          {language.label || "-"}
        </span>
      </div>
      <div className="d-flex justify-content-between">
        <label className="text-sm">Board:</label>
        <span className="text-bold text-sm text-dark mb-1 text-right">
          {board.label || "-"}
        </span>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <label className="text-sm">Stream:</label>
        <span className="text-bold text-sm text-dark mb-1">
          {stream.label || "-"}
        </span>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <label className="text-sm">Course IDs:</label>
        <span className="text-bold text-sm text-dark mb-1">
          {courses?.length} selected
        </span>
      </div>

      <h4 className="mt-2 text-bold">Year Details</h4>
      <div className="d-flex align-items-center justify-content-between">
        <label className="text-sm">Year:</label>
        <span className="text-bold text-sm text-dark mb-1">
          {year.label || "-"}
        </span>
      </div>

      <h4 className="my-3 text-bold">Material Details</h4>
      {selectedMaterials.length ? (
        selectedMaterials.map((item, index) => (
          <div
            style={{ background: "#f9fafb", borderRadius: "8px" }}
            className="p-3 rounded-lg mb-3"
            key={item.packageCodeId}
          >
            <div className="d-flex align-items-center justify-content-between">
              <label className="text-sm">Package {index + 1}:</label>
              <span className="text-bold text-sm text-dark mb-1">
                {item.packageCodeId}
              </span>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <label className="text-sm mb-0">Material IDs:</label>
              <span className="text-bold text-sm text-dark">
                {item?.materialIds.length} selected
              </span>
            </div>

            <div className="d-flex flex-wrap">
              {item.materialIds.map((item) => (
                <Tooltip title={item.label} key={item.value}>
                  <div
                    key={item.value}
                    className="mt-1 ml-1 text-xs text-bold py-1 px-2 rounded"
                    style={{
                      background: "#dcfce7",
                      color: "#166534",
                    }}
                  >
                    {item.value}
                  </div>
                </Tooltip>
              ))}
            </div>
          </div>
        ))
      ) : (
        <p className="text-center">No packages added</p>
      )}

      <hr />

      <h4 className="my-3 text-bold">Course IDs</h4>
      <div className="d-flex flex-wrap">
        {courses?.map((item) => (
          <Tooltip title={item.label} key={item.value}>
            <div
              key={item.value}
              className="mr-2 mb-2 text-xs text-bold py-1 px-2 rounded"
              style={{
                background: "#dbeafe",
                color: "#1e40af",
              }}
            >
              {item.value}
            </div>
          </Tooltip>
        ))}
      </div>

      {id && (
        <>
          <hr className="my-3" />
          <h4 className="mb-2 text-bold">Created On</h4>

          <p className="text-sm">
            {createdOn}
            <span>
              {" "}
              <ViewEmployeeName empId={createdBy} />
            </span>
          </p>

          <h4 className="mb-2 text-bold">Updated On</h4>
          <p className="text-sm">
            {updatedOn}
            <span>
              {" "}
              <ViewEmployeeName empId={updatedBy} />
            </span>
          </p>
        </>
      )}
    </>
  );
};

export default UserStateSummary;
